module.exports = __webpack_public_path__ + "static/media/IMG_1852.f9020693.JPG";